import {Scheduler} from "./Scheduler";

(function ($) {
    var $body = $('body');

    $(document).ready(function () {

        $.validator.messages.required = 'To pole jest wymagane.';
        $.validator.messages.email = 'Nieprawidłowy adres email.';
        $.validator.addMethod('lettersonly', function (value, element) {
            return this.optional(element) || /^[a-zA-Z\- ąćęłńóśżźĄĆĘŁŃÓŚŻŹ]+$/i.test(value);
        }, 'Dozwolone są tylko litery oraz znak "-".');

        $.validator.addMethod('phone', function (value, element) {
            return this.optional(element) || /^[0-9\-+() ]+$/i.test(value);
        }, 'Pole zawiera niedozwolone znaki.');

        var storedFiles = [];

        $('#contact-form .form__input').each(function () {
            var $input = $(this);

            if ($input.val().length > 0) {
                $input.addClass('valid');
            }
        });

        $('#file').on('change', handleFileSelect);
        $(document).on('click', '.remove-file', removeFile);

        var selDiv = '',
            attachments = $('#attachments'),
            fileErrors = $('#file_errors');

        function handleFileSelect(e) {
            var files = e.target.files;
            var filesArr = Array.prototype.slice.call(files);
            var device = $(e.target).data('device');
            var validExts = [
                'jpg',
                'png',
                'jpeg',
                'csv',
                'pdf',
                'odt',
                'docx',
                'doc',
                'txt',
                'mp4',
                'avi',
                'srt',
                'vtt',
                'zip',
                'mp3',
                'gif',
                'xls',
                'xlsx',
                'ods'
            ];
            var file_max_size = 15242880;

            fileErrors.empty();

            filesArr.forEach(function (f, i) {

                var reader = new FileReader(),
                    file_ext = f.name.split('.').pop().toLowerCase();

                if ($.inArray(file_ext, validExts) == -1) {
                    reader.onload = function (e) {
                        var html = '<li style="color:red;"><div>' + f.name + '</div><div class="remove-file" data-file="' + f.name + '"><span>&times;</span></div><div class="filerr">(Nieprawidłowy format pliku.)</div></li>';
                        attachments.append(html);
                    };
                } else if (f.size > file_max_size) {
                    reader.onload = function (e) {
                        var html = '<li style="color:red;"><div>' + f.name + '</div><div class="remove-file" data-file="' + f.name + '"><span>&times;</span></div><div class="filerr">(Plik jest za duży.)</div></li>';
                        attachments.append(html);
                    };
                } else {

                    var name = f.name.split('.')
                            .shift()
                            .replace(/[^0-9a-zA-Z\-_()\[\] ąćęłńóśżźĄĆĘŁŃÓŚŻŹ]+/g, '_'),
                        newFileName = name + '.' + file_ext;

                    f = new File([f], newFileName);

                    reader.onload = function (e) {
                        var html = '<li><div>' + f.name + '</div><div class="remove-file" data-file="' + f.name + '"><span>&times;</span></div></li>';
                        attachments.append(html);
                    };
                }

                storedFiles.push(f);
                reader.readAsDataURL(f);

            });

        }

        function removeFile(e) {

            var file = $(this).data('file');

            for (var i = 0; i < storedFiles.length; i++) {
                if (storedFiles[i].name === file) {
                    storedFiles.splice(i, 1);
                    break;
                }
            }
            $(this).parent().remove();
            if ($.isEmptyObject(storedFiles)) {
                $('#file').val('');
            }
        }

        $('#back-to-contact').on('click', function (e) {
            e.preventDefault();
            storedFiles = [];
            attachments.empty();
            $('#contact-typ').fadeOut(300, function () {
                $('#contact-form-wrapper, #contact-img').fadeIn(300);
                $('textarea').css('height', 'auto');
            });
        });

        $('.form__row--file')
            .on('dragover', function () {
                $(this).find('.file-container__content').addClass('dragenter');
            })
            .on('dragleave mouseleave', function () {
                $(this).find('.file-container__content').removeClass('dragenter');
            });

        $('.career-apply .toggle-checks').on('click', function () {
            let $this = $(this),
                $container = $this.parents('.checkbox-list-container'),
                $checkboxList = $container.find('.checkbox-list');

            $checkboxList.toggleClass('expanded');

            if ($checkboxList.hasClass('expanded')) {
                $this.find('.expand').hide(0);
                $this.find('.collapse').show(0);
            } else {
                $this.find('.expand').show(0);
                $this.find('.collapse').hide(0);
            }
        });

        $('.apply-offer').click(function() {
            var $button = $(this),
                $form = $('.career-apply'),
                offerName = $button.attr('data-offer-name'),
                contactUrl = $button.attr('data-url');

            if (contactUrl.length === 0) {
                $form.find('[name="offerName"]').val(offerName);
                $form
                    .css('display', 'block')
                    .velocity('fadeIn', {duration: 300});

                $body.css('overflow', 'hidden');
                $('#page-wrapper').addClass('modal-open');
                $('#scroll-to-top').fadeOut();
            } else {
                window.open(contactUrl, '_blank');
            }
        });

        $('.career-apply .accept-all-checks').on('change', function () {
            let $this = $(this),
                $container = $this.parents('.checkbox-list-container'),
                checked = $this.prop('checked');

            $container
                .find('input[type="checkbox"]')
                .prop('checked', checked);
        });

        $('.career-apply .checkbox-list input[type="checkbox"]').on('change', function () {
            let $this = $(this),
                $list = $this.parents('.checkbox-list'),
                $checkboxes = $list.find('input[type="checkbox"]'),
                $mainCheckbox = $this
                    .parents('.checkbox-list-container')
                    .find('.accept-all-checks'),
                all = true;

            $checkboxes.each(function () {
                if (!$(this).is(':checked')) {
                    all = false;
                }
            });

            $mainCheckbox.prop('checked', all);
        });

        $('.career-apply .close-modal').on('click', function() {
            var $container = $(this).parents('.career-apply');

            $container.velocity('fadeOut', {duration: 300})
                .then(function() {
                    $container.css('display', 'none');
                });

            $('#page-wrapper').removeClass('modal-open');
            $('#scroll-to-top').fadeIn();
            $body.css('overflow', 'auto');
            // $('#page-header').css('z-index', '1001');
        });

        // Tabs animations
        var $tabsContainer = $('.wp-block-ub-tabbed-content-tabs-content');
        $tabsContainer.css('height', $tabsContainer.outerHeight());

        $('.wp-block-ub-tabbed-content-tab-title-wrap').on('click', resizeTabs);
    });

    $(window).on({
        resize: function() {
            Scheduler.add(function() {
                $('.wp-block-ub-tabbed-content-tab-title-wrap.active').each(resizeTabs);
            }, null, 100);

        }
    })

}(jQuery));


function resizeTabs() {
    var $that = $(this),
        index = $that.index(),
        $tabsContainer = $that
            .closest('.wp-block-ub-tabbed-content')
            .find('.wp-block-ub-tabbed-content-tabs-content'),
        $tab = $tabsContainer.find('.wp-block-ub-tabbed-content-tab-content-wrap').eq(index),
        tabHeight = $tab.outerHeight();

    $tabsContainer.stop().velocity({height: tabHeight}, 300);
}

function initialize() {
    var mapOptions = {
            center: {
                lat: 51.1132255,
                lng: 17.0520433
            },
            zoom: 13,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            styles: [
                {
                    'elementType': 'geometry',
                    'stylers': [
                        {
                            'color': '#F5F5F5'
                        }
                    ]
                },
                {
                    'elementType': 'labels.icon',
                    'stylers': [
                        {
                            'visibility': 'off'
                        }
                    ]
                },
                {
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#616161'
                        }
                    ]
                },
                {
                    'elementType': 'labels.text.stroke',
                    'stylers': [
                        {
                            'color': '#F5F5F5'
                        }
                    ]
                },
                {
                    'featureType': 'administrative.land_parcel',
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#BDBDBD'
                        }
                    ]
                },
                {
                    'featureType': 'poi',
                    'elementType': 'geometry',
                    'stylers': [
                        {
                            'color': '#EEEEEE'
                        }
                    ]
                },
                {
                    'featureType': 'poi',
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#757575'
                        }
                    ]
                },
                {
                    'featureType': 'poi.park',
                    'elementType': 'geometry',
                    'stylers': [
                        {
                            'color': '#E5E5E5'
                        }
                    ]
                },
                {
                    'featureType': 'poi.park',
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#9E9E9E'
                        }
                    ]
                },
                {
                    'featureType': 'road',
                    'elementType': 'geometry',
                    'stylers': [
                        {
                            'color': '#FFFFFF'
                        }
                    ]
                },
                {
                    'featureType': 'road.arterial',
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#757575'
                        }
                    ]
                },
                {
                    'featureType': 'road.highway',
                    'elementType': 'geometry',
                    'stylers': [
                        {
                            'color': '#DADADA'
                        }
                    ]
                },
                {
                    'featureType': 'road.highway',
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#616161'
                        }
                    ]
                },
                {
                    'featureType': 'road.local',
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#9E9E9E'
                        }
                    ]
                },
                {
                    'featureType': 'transit.line',
                    'elementType': 'geometry',
                    'stylers': [
                        {
                            'color': '#E5E5E5'
                        }
                    ]
                },
                {
                    'featureType': 'transit.station',
                    'elementType': 'geometry',
                    'stylers': [
                        {
                            'color': '#EEEEEE'
                        }
                    ]
                },
                {
                    'featureType': 'water',
                    'elementType': 'geometry',
                    'stylers': [
                        {
                            'color': '#C9C9C9'
                        }
                    ]
                },
                {
                    'featureType': 'water',
                    'elementType': 'labels.text.fill',
                    'stylers': [
                        {
                            'color': '#9E9E9E'
                        }
                    ]
                }
            ]
        },
        mapContainer = document.getElementById('googlemap'),
        map,
        center,
        marker;

    if (mapContainer === null) {
        return;
    }

    map = new google.maps.Map(mapContainer, mapOptions);
    marker = new google.maps.Marker({
        position: map.getCenter(),
        icon: FR.theme_url + '/assets/img/pin.png',
        map: map,
        title: 'Szczytnicka 11/5'
    });

    setInterval(function () {
        toggleBounce();
    }, 1500);

    function toggleBounce() {
        if (marker.getAnimation() !== null) {
            marker.setAnimation(null);
        } else {
            marker.setAnimation(google.maps.Animation.BOUNCE);
        }
    }

    // calculate the center with getCenter
    function calculateCenter() {
        center = map.getCenter();
    }

    google.maps.event.addDomListener(map, 'idle', function () {
        calculateCenter();
    });
    google.maps.event.addDomListener(window, 'resize', function () {
        map.setCenter(center);
    });
    google.maps.event.addListener(marker, 'click', function () {
        map.setZoom(15);
        map.setCenter(marker.getPosition());
    });
}

window.addEventListener('load', initialize);
